module.exports = __webpack_public_path__ + "img/img-item-c.4e4d9862.png";